export default "__VITE_ASSET__3afbbf58__"